import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as CommonConstants from '../utils/common.constants';
import { FileUploadModule } from 'primeng/primeng';

@Injectable()
export class PatientService {
  
  constructor(private http: HttpClient) {
  }
 
  savePatient(saveData): Observable<any> {
    return this.http.post(CommonConstants.env +'api/patient/patient/create', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  saveAdministrations(saveData): Observable<any> {
    return this.http.post(CommonConstants.env +'api/patient/administrations/create', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  
  saveFinancials(saveData): Observable<any> {
    return this.http.post(CommonConstants.env +'api/patient/financials/create', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  savePatientAddress(saveData): Observable<any> {
    return this.http.post(CommonConstants.env +'api/patient/patient/address/create', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  savePatientContact(saveData): Observable<any> {
    return this.http.post(CommonConstants.env +'patient/employee/create', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  saveLogistics(saveData): Observable<any> {
    return this.http.post(CommonConstants.env +'api/patient/logistic/create', saveData).
    pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  getFinanceById(financeId: number): Observable<any> {
    return this.http.get(CommonConstants.env + 'api/partner/practitioner/' + financeId).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  searchFinance(finance, startIndex) {
    return this.http.post(CommonConstants.env + 'api/partner/finance',finance);
     //+ '?start=' + startIndex + '&size='
     // + CommonConstants.PAGINATION_SIZE, practitioner)
  }

  errorHandler(error: any): void {
    throwError(error);
  };

  
  searchLogistics(logistics, startIndex) {
    return this.http.post(CommonConstants.env + 'api/partner/logistics',logistics);
    // + '?start=' + startIndex + '&size='
      //+ CommonConstants.PAGINATION_SIZE, logistics) 
     // return this.http.get(CommonConstants.env + 'api/partner/logistics');
  }
  saveInsurance(saveData): Observable<any> {
    return this.http.post(CommonConstants.env +'api/partner/insurance/create', saveData).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  deletePatientPartnerType(patientId, adminId, partnerType): Observable<any> {
    let url;
    switch (partnerType) {
      case CommonConstants.PARTNER_ADMINISTRATION_TYPE:
        url = CommonConstants.env + 'api/patient/patient/administrations/delete/' + patientId + "/" + adminId;
        break;
      case CommonConstants.PARTNER_FINANCIAL_TYPE:
        url = CommonConstants.env + 'api/patient/patient/financials/delete/' + patientId + "/" + adminId;
        break;
      case CommonConstants.PARTNER_LOGISTICS_TYPE:
        url = CommonConstants.env + 'api/patient/patient/logistics/delete/' + patientId + "/" + adminId;
        break;
    }
    return this.http.delete(url);
  }

  getPatientById(pteId: number): Observable<any> {
    return this.http.get(CommonConstants.env + 'api/patient/patient/' + pteId).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  /* deleteFinancials(patientId, adminId): Observable<any> {
    return this.http.delete(CommonConstants.env +'api/patient/patient/financials/delete/'+patientId+"/"+adminId,);
  }

  deleteLogistics(patientId, adminId): Observable<any> {
    return this.http.delete(CommonConstants.env +'api/patient/patient/logistics/delete/'+patientId+"/"+adminId,);
  } */

  searchInsurance(insurance, startIndex) {
    return this.http.post(CommonConstants.env + 'api/partner/insurance',insurance);
    // + '?start=' + startIndex + '&size='
      //+ CommonConstants.PAGINATION_SIZE, logistics) 
     // return this.http.get(CommonConstants.env + 'api/partner/logistics');
  }

  getPatients(obj: any): Observable<any> {
    return this.http.post(CommonConstants.env + 'api/patient/patient/search', obj);
  }
 

  postFile(formData): Observable<any> {
    let url = CommonConstants.env+'api/master/upload';
    let uplo: File;
    return this.http.post(url, formData);
   // return this.http.get(url);
  }
  getFinancials(selectedMedfiId: any) : Observable<any>{
    return this.http.get(CommonConstants.env + 'api/patient/financials/' + selectedMedfiId).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }
  getLogistics(selectedMedfiId: any): Observable<any> {
    return this.http.get(CommonConstants.env + 'api/patient/logistic/' + selectedMedfiId).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  } 
  
}
